import { enGB } from 'date-fns/locale';
import { PrescriberType } from '@customer-frontend/doctor';
import { Config } from '../type';
import { defaultConfig } from './default';

export const CompoundUKConfig: Config = {
  ...defaultConfig,
  analyticsBrand: 'compound',
  brand: 'compound-uk',
  loginUrl: '/login',
  title: 'Compound',
  consentRequired: true,
  prescriberType: PrescriberType.PRESCRIBER,
  stripeApi: 'PAYMENT_INTENT',
  country: 'United Kingdom',
  countryCode: 'GB',
  locale: 'en-GB',
  currency: 'GBP',
  emergencyNumber: '999',
  supportEmail: 'hello@compound.co',
  medicalEmail: 'hello@compound.co',
  rejectionContactLink: 'https://help.uk.compound.co/hc/en-au/requests/new',
  helpCentreUrl: 'https://help.uk.compound.co/hc/en-au',
  zendeskRequestUrl: 'https://help.uk.compound.co/hc/en-au/requests/new',
  weightPausingAccountZendeskParams: {
    tf_25854283026457: 'manage_my_account_uk',
    tf_15562527346841: 'account_pause_clone',
  },
  weightRefillNowZendeskParams: {
    tf_25854283026457: 'medical_support_uk',
    tf_15562018357657: 'med_err_clone',
  },
  weightResumeNowZendeskParams: {
    tf_25854283026457: 'general_question_uk',
    tf_25849723182233: 'general_enquirys',
  },
  trustpilotLink: '',
  trustPilotEnabled: false,
  contactUsUrl: 'https://help.uk.compound.co/hc/en-au/requests/new',
  dateConfig: {
    ...defaultConfig.dateConfig,
    datefnsLocale: enGB,
  },
  selfServiceCancelEnabled: false,
  localisedAssets: {
    phoneCall: '/assets/phone-call.svg',
  },
  externalSupportNumber: '1800 022 222',
  externalSupportLabel: 'HealthDirect',
  showOnboardingQuiz: true,
  consultationCreateAccountPage: true,
  // TODO: https://linear.app/eucalyptus/issue/ENG-2624/[customer-frontend]-update-config-appstore-and-playstore-links
  appStoreLinks: {
    appStore: '',
    playStore: '',
  },
  verifyIdentity: true,
  shouldPresentPhoneFieldAtCreateAccount: false,
  flexiBrand: true,
  pausePurchaseFaqTypeformUrl: 'https://eucalyptus-vc.typeform.com/cancelform',
  purchasePrompts: {
    initialPurchaseConfirmPersonalDetails: true,
    initialPurchaseContents: 'condensed',
    initialPurchaseAddresses: new Set(['residential'] as const),
    initialPurchaseShowSimplifiedShippingAddressForm: false,
    supportShippingAddressValidation: false,
    collectDeliveryInstructionsUpfront: false,
    collectDeliveryInstructions: false,
    showCheckoutReassurance: false,
    showMarketingOptInCheckbox: true,
    showDeliveryConstraintCard: false,
    showTermsAndConditionsCheckbox: true,
    showZendeskSupportCard: false,
  },
  purchaseActivationFlow: {
    moneyBackGuaranteeDays: 25,
  },
  weightDashboardEnabled: false,
  urlPaths: {
    ...defaultConfig.urlPaths,
    about: '/program',
    termsAndConditions: '/terms-conditions',
    privacyNotice: '/privacy-policy',
  },
  hasMobileApp: false,
};
